/* Serialización del modelo Notificación */
export interface NotificacionDTO {
  id: number;
  mensaje: string;
  tipo: TipoNotificacion;
  url: string | null;
  leida: boolean;
  fecha_creacion: string;
}

/* Tipos de notificación */
export enum TipoNotificacion {
  ERROR = 'error',
  EXITO = 'exito',
  INFO = 'info',
}
